export function contributionForGap(gap, gapTarget, taxesLevies = 0, otherCosts = 0, buyingLeverage = 1) {
  const leverage = Number(buyingLeverage);
  const safeLeverage = Number.isFinite(leverage) ? leverage : 1;
  const base = Math.round((Number(gap) || 0) * (Number(gapTarget) || 0) / 100 * safeLeverage);
  const taxes = Number(taxesLevies) || 0;
  const other = Number(otherCosts) || 0;

  return base + taxes + other;
}

export function currentTopUpAmount() {
  const checkbox = document.getElementById("scenario_top_up_enabled");
  if (checkbox && !checkbox.checked) return 0;

  const amountInput = document.getElementById("scenario_top_up_amount");
  if (!amountInput) return 0;

  const parsed = Number.parseFloat(String(amountInput.value ?? "").replace(/,/g, "").trim());
  return Number.isFinite(parsed) ? parsed : 0;
}

export function applyAddOnToScenarioTotals() {
  const addOn = currentTopUpAmount();

  document.querySelectorAll("[data-scenario-total-with-add-on]").forEach((node) => {
    const base = Number(node.dataset.baseContribution);
    if (!Number.isFinite(base)) return;

    node.textContent = (base + addOn).toLocaleString();
  });
}

// Each facility tab shows the summed costs of the table rows tagged with its
// panel id. Entries without a panel id (declined rows, intermediary scenarios) are skipped.
export function dispatchPanelCosts(entries) {
  const totals = {};
  entries.forEach(({ panelId, taxes, other }) => {
    if (!panelId) return;

    totals[panelId] ||= { taxes: 0, other: 0 };
    totals[panelId].taxes += taxes;
    totals[panelId].other += other;
  });

  Object.entries(totals).forEach(([panelId, { taxes, other }]) => {
    window.dispatchEvent(
      new CustomEvent("scenario-modeling:costs-change", {
        detail: { panelId, taxesLevies: taxes, otherCosts: other },
      }),
    );
  });
}
